import { render, staticRenderFns } from "./ProgramName.vue?vue&type=template&id=08b67ae1&scoped=true"
import script from "./ProgramName.vue?vue&type=script&lang=js"
export * from "./ProgramName.vue?vue&type=script&lang=js"
import style0 from "./ProgramName.vue?vue&type=style&index=0&id=08b67ae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b67ae1",
  null
  
)

export default component.exports